import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IMenuFilter } from '@nimbus-library/features/menu';
import { IPermissionManagerService } from '@nimbus-library/features/user-settings/services/contracts/i-permission-manager.service';
import { GlobalPermissionsModel } from '@nimbus-global/features/permissions/models/global-permissions.model';

export class GlobalPermissionsModelFilter implements IMenuFilter {
  public constructor(
    private readonly permissionManagerService: IPermissionManagerService,
    private readonly action: (model: GlobalPermissionsModel) => boolean,
  ) {}

  public validate$(): Observable<boolean> {
    return this.permissionManagerService.getGlobalPermissionsModel$().pipe(map((model) => this.action(model)));
  }
}
